<ll-titulo>Ensayos Mensuales {{ months[month] }}</ll-titulo>

<div *ngIf="month !== undefined">
    <instrumentos-mensual
        [month]="month"
        [year]="year"
        [tipoInstrumento]="config.plataforma.instrumentoMensualTipo"
    ></instrumentos-mensual>
</div>
